<template>
  <card-seplag
    :titulo="campos && campos.length > 0 && campos[0].descQuestionario ? campos[0].descQuestionario : 'Questionário padrão'"
    cor="#00acc1" :cols="cols">
    <!-- <card-seplag v-for='categoria in categorias' :key="categoria.idenCategoriaPergunta" :titulo="categoria.nome">
      <rotulo v-for="campo in categoria.campos" :key="campo.idenPergunta"
        :requerido="campo.flagObrigatorio == 'S' && !isDisabled? true : false"
        :nome="campo.numrOrdemPergunta+' - '+campo.descPergunta" :cols="tamanhoColunas(campo.siglTipoPergunta)"> -->
        <!-- <InputMask :disabled="isDisabled" mask="999,9" v-model="campo.valrRespostaQuesPergunta" :id="campo.idenPergunta"
          v-if="campo.siglTipoPergunta=='TEXTO'" @keyup="changeValueCampo" /> -->
        
        <!-- <input type="text" v-maska data-maska="['##,#','###,#','####,#','#####,#','######,#','#######,#','########,#','#########,#','##########,#']" v-model="campo.valrRespostaQuesPergunta" :id="campo.idenPergunta" :unmask="false"
        v-if="campo.siglTipoPergunta=='TEXTO'" @keyup="changeValueCampo" class="p-inputmask p-inputtext p-component"/>

        <input :disabled="isDisabled" v-maska data-maska="['###','####','#####','######','#######','########','#########','##########']" v-model="campo.valrRespostaQuesPergunta" :id="campo.idenPergunta"
          v-if="campo.siglTipoPergunta=='NUMEROINTEIRO'" @keyup="changeValueCampo" class="p-inputmask p-inputtext p-component"/>

        <Textarea :disabled="isDisabled" type="text" v-model="campo.valrRespostaQuesPergunta" :id="campo.idenPergunta"
          v-if="campo.siglTipoPergunta=='TEXTOAREA' && condicao(campo,campos)" :rows="rowsTextArea"
          @keyup="keyupFn(campo)" />
        <span class="contador-caracteres"
          v-if="campo.siglTipoPergunta === 'TEXTO' && IsMaximoCaracteres && condicao(campo,campos)">
          {{QtdMaximoCaracteres - (campo.data ?campo.data.length : 0) }} caracteres restantes</span> -->

        <!-- <SelectButton  :disabled="isDisabled" v-model="campo.valrRespostaQuesPergunta" :options="campo.options" optionLabel="name" optionValue="code" v-if="campo.siglTipoPergunta=='OPCAOUNICA'" @input="changeValueCampo"/> -->

        <!-- <div v-if="campo.siglTipoPergunta=='OPCAOUNICA'">
          <div style="display:flex;flex-direction:row">
            <div v-for="option in campo.options" :key="option.code"
              style="display:flex;align-items: center; justify-content: flex-start;margin:2px; padding-right: 10px; padding-bottom: 8px">
              <RadioButton :inputId="campo.idenPergunta" :name="campo.idenPergunta" :value="option.code"
                v-model="campo.valrRespostaQuesPergunta" @change="checkRadioInput($event)" />

              <label style="margin-left:10px">{{option.name}}</label>
            </div>

          </div>
        </div>

        <div v-if="campo.siglTipoPergunta=='OPCAOMULTIPLA'">
          <div v-for="element in campo.options" :key="element.code" class="p-field-checkbox">
            <Checkbox :disabled="isDisabled" :id="element.code" :inputId="element.code" :value="element" name="element"
              v-model="campo.valrRespostaQuesPergunta" v-if="campo.siglTipoPergunta=='OPCAOMULTIPLA'"
              @change="changeValueCampo" />
            <label :for="element.code" v-if="campo.siglTipoPergunta=='OPCAOMULTIPLA'">{{element.name}}</label>
          </div>
        </div>

        <InputMask :disabled="isDisabled" v-model="campo.valrRespostaQuesPergunta" mask="99/99/9999"
          placeholder="dd/mm/aaaa" v-if="campo.siglTipoPergunta=='DATA'" @keyup="changeValueCampo" />

        <Dropdown :disabled="isDisabled" v-model="campo.valrRespostaQuesPergunta" :options="campo.options"
          optionLabel="name" optionValue="code" :placeholder="campo.placeHolder" v-if="campo.siglTipoPergunta=='LISTA'"
          @change="changeValueCampo" />
      </rotulo> 
    </card-seplag>-->


    <!-- Estático -->

  </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
// import Rotulo from '@/template/RotuloSeplag.vue'
import gridCss from '@/common/grid'
import { vMaska } from "maska"
// import func from 'vue-editor-bridge'

export default {

    name: 'QuestionarioSeplag',   
    directives: { maska: vMaska },
    components: {CardSeplag },//,Rotulo
      data: function(){      
        return {            
          // checkBoxElements : ""
          categorias: []
        }
    },
    // model: {
    //     prop: 'campos',
    //     event: 'change'
    // },
    props: {
        
        titulo: {
          // Especifica o titulo a ser exibido no cabeçalho da tabela
          type: String,
          default: null
        },
        cols: {
          // Especifica o titulo a ser exibido no cabeçalho da tabela
          type: String
        },
        campos: {
          // Arrays dos campos a serem exibidos na tela
          // Converter Opcoes para o padrão do Map abaixo
          // .map((questao) => {
          //   return {
          //     ...questao,
          //     options: questao.opcoes.split('/ ').map((opcao) => {
          //       return {
          //         code: opcao,
          //         name: opcao,
          //       };
          //     }),
          //   };
          // })
        type: Array,
          required: true
        },
        IsMaximoCaracteres:{
          // Existe quantidade máxima de caracteres (para campo texto) ?
          type:Boolean,
        },
        QtdMaximoCaracteres:{
          // Caso existe limite de caracteres. Quantos caracteres pode?
          type:Number,
        },
        rowsTextArea:{
          // Quantitdade maxima de linha ara campo texto. 
          // Caso não informe nada para esse campo o valor padrão é 10.
          type:Number,
          default: 10
        },
        condicao:{
          type:Function,
          default: () => true
        },
        isDisabled:{
          default:false
        }
    },
    methods:{
      colGrid(colunas) {
        return gridCss(colunas ? colunas : '12') 
      },
      keyupFn(campo){
        this.changeValueCampo()
        if(this.IsMaximoCaracteres){
          campo.data = campo.data.substring(0,this.QtdMaximoCaracteres);
        }
      },
      convertOpcoes(data) {
       let resultado =" ";
       
       resultado = data.split('/ ')
         .map((opcao) => {
              return {
                code: opcao,
                name: opcao,
              };
            })

            return resultado;           
      },
      tamanhoColunas(campo) {
        switch (campo) {
          case "TEXTO":
            return "12 6";           
          case 'OPCAOUNICA':
            return "12 4";
          case 'DATA':
            return "12 6";

          case 'LISTA':
            return "12 6";
          case 'OPCAOMULTIPLA':
            return "12 6";
          default:
            return "12 6";
        }
      },
      convertArrayToString() {
       
      },
      changeValueCampo(e){
        this.$emit('changeValueCampo',e)
      },
      checkRadioInput(event) {
        event.target.value=true;
        var data = event.target.value;     
        
      },
    },
    mounted(){
        let selectButton = document.querySelectorAll('.div-opcao-unica- > div')        
        selectButton.forEach(element =>{
            const numChildren = element.children.length;
            const numFr = 100/numChildren;

            element.style.display = 'grid';
            element.style.gridTemplateColumns=`repeat(${numChildren},${numFr}fr)`
        })
       
        let selectButtonItens = document.querySelectorAll('.div-opcao-unica > div > div')        
        selectButtonItens.forEach(element =>{
            element.style.width = '100%';
            element.style.padding= '0.3em 1em';
            element.style.display= 'flex';
            element.style.alignItems= 'center';
            element.style.justifyContent= 'center';
        }) 
        for(let i=0; i<this.campos.length; i++){
          if(this.categorias.length==0){
            let categoria = {
              id: this.campos[i].idenCategoriaPergunta, 
              nome: this.campos[i].descCategoriaPergunta,
              campos:[] 
            }
            categoria.campos.push(this.campos[i])
            this.categorias.push(categoria);
          }else{
            let campo = this.campos[i].idenCategoriaPergunta
            let verifica = this.categorias.filter(function(elemet){
              return elemet.id == campo;
            })

            if(verifica.length==0){
              let categoria = {
                id: this.campos[i].idenCategoriaPergunta, 
                nome: this.campos[i].descCategoriaPergunta,
                campos:[] 
              }
              categoria.campos.push(this.campos[i])
              this.categorias.push(categoria);
            }else{
              for(let j=0; j<this.categorias.length;j++){
                if(this.categorias[j].id == this.campos[i].idenCategoriaPergunta){    
                  this.categorias[j].campos.push(this.campos[i])
                  break;
                }
              }
            }
          }
        }  
    }
}
</script>

<style scoped>

    .div-questionario{
      margin-bottom:1rem;
      width: 100%;
    }

    .p-field-checkbox {
      display: flex;
      margin-bottom: 0.3rem;
    }

  .p-field-checkbox > label {
    margin-left: 0.5rem;
  }
</style>